/**
 * cookies处理
 * 依赖于 js cookie
 */
 import Cookies from 'js-cookie'

 const cookieStore = (() => {
   let cookieDomain = location.hostname
   if (cookieDomain.indexOf('bluestonehk.com') > 0) {
     cookieDomain = 'bluestonehk.com'
   }
   return {
     get(name) {
       return Cookies.get(name)
     },
     set(name, value) {
       return  Cookies.set(name, value, {
         path: '/',
         domain: cookieDomain
       })
     },
     remove(name) {
       return Cookies.remove(name, {
         path: '/',
         domain: cookieDomain
       })
     },
   };
 })();
 
 Object.defineProperty(window, 'cookieStore', {
   value: cookieStore
 });
 


// WEBPACK FOOTER //
// ./src/utils/cookieStore.js